module.exports = __webpack_public_path__ + "img/walkthrough_1.a3c8b4ff.png";